/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Table, Badge, Form, Dropdown } from "react-bootstrap";
import {
  BiDotsHorizontalRounded,
  BiSearch,
  BiMenuAltRight,
  BiSort,
} from "react-icons/bi";
import moment from "moment";
import { CgSortAz } from "react-icons/cg";
import { toast } from "react-toastify";
import FormService from "../../core/services/FormService";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER,
  STATUS
} from "../../core/constants/common";
import PaginationBox from "../../components/Pagination/PaginationBox";
import FormCreate from "../FormCreate/FormCreate";
import { objectPattern } from "@babel/types";
import { FormContext } from "../../App";

const FormLists = () => {
  const [forms, setForms] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [isRename, setIsRename] = useState(false);
  const [formData, setFormData] = useState({});
  const [id, setId] = useState("");
  const formObj = useContext(FormContext);
  
  const navigate = useNavigate();

  useEffect(() => {
    getForms(0, itemsPerPage, searchKey, sortField);
  }, []);

  const getForms = (pageNumber, itemsPerPageVal, searchVal = "", sortField) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    FormService.listForms(pageNumber, perPage, searchVal, sort)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        // console.log(response.data);
        setForms([...response.data]);
      })
      .catch((error) => {
        console.log("err", error);
      });
  };
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getForms(0, itemsPerPage, searchKey, val);
  };
  const handleSearch = (e) => {
    getForms(0, itemsPerPage, searchKey, sortField);
  };
  const handleRename = (e, item) => {
    e.preventDefault();

    // const obj = {
    //   id: id,
    //   name: name,
    //   description: desc,
    //   formType: type,
    //   languages: lang,
    // };
    setFormData(item);
    setIsRename(true);
  };
  const callbackFn = (val) => {
    setIsRename(val);
    
    getForms(currentPage, itemsPerPage, searchKey, sortField);
  };
  return (
    <>
      <div className="row mx-0 p-1 mb-2">
        <div className="col-lg-12 py-2 px-0">
          <ul className="AllForm_list_tab">
            <li className="active">All</li>
            <li>Recently viewed</li>
            <li>Draft</li>
            <li>Open</li>
          </ul>
        </div>
        <div className="col-lg-12 py-2 px-0">
          <div className="List_Header py-2">
            <div className="search_box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  value={searchKey}
                  onChange={(e) => setSearchKey(e.target.value)}
                />
                <Link to="#" className="Search_icon">
                  <BiSearch onClick={handleSearch} />
                </Link>
              </Form>
            </div>
            <div className="Filter_box_menu">
              <ul>
                <li>
                  <a href="#">
                    <BiMenuAltRight /> Sort
                  </a>
                </li>
                <li className="filter">
                  <a href="#">
                    <CgSortAz /> Filter
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="List_tableCard card">
            <Table className="add_checkbox m-0">
              <thead>
                <tr>
                  <th>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("name")}>
                      Form Title <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("lastModifiedDate")}>
                      Modified date <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("formType")}>
                      Type <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("formType")}>
                      Language <BiSort />
                    </Link>
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {forms!=null && forms!==undefined && forms.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault1"
                      />
                    </td>
                    <td>{item.name}</td>
                    <td>
                      {moment(item.lastModifiedDate).format("MMM DD, YYYY")}
                    </td>
                    <td>{item.formType}</td>
                    <td>
                      {item.languages!=null && item.languages !== undefined && item.languages.length > 0 &&
                        item.languages.map((lang) => lang.name)}
                    </td>
                    <td>
                      {(() => {
                        switch (item.status) {
                          case "PUBLISHED":
                            return (
                              <Badge bg="badge-green">{STATUS[item.status]}</Badge>
                            );
                          case "DRAFT":
                            return <Badge bg="secondary">{STATUS[item.status]}</Badge>;
                          case "ARCHIVED":
                            return <Badge bg="badge-red">{STATUS[item.status]}</Badge>;
                          default:
                            return " ";
                        }
                      })()}
                    </td>
                    <td>
                      
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="blank_outline"
                          id="dropdown-basic"
                        >
                          <BiDotsHorizontalRounded />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            as={Link}
                            to={`/form_builder/form_edit/${item.id}/${
                              item.languages.length > 0 && item.languages[0].id
                            }`}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            href="#"
                            onClick={(e) =>
                              handleRename(
                                e,
                                item
                              )
                            }
                          >
                            Rename
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {(isRename) && (
              <FormCreate
                isRename={isRename}
                form={formData}
                callbackFn={callbackFn}
              />
            )}
            <div className="table_countFooter p-2">
              <PaginationBox
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getForms(pageNum, perPage, searchKey, sortField);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormLists;
